import { Note } from "common";
import { NoteBody } from "./NoteBody";
import { Link as ReactRouterLink } from "react-router-dom";
import { Text, Link } from "@chakra-ui/react";
import { THEME_COLOR_SCHEME } from "../utils/theme";
import { useNoteAccount } from "./useNoteAccount";
import { useNoteAccountName } from "./useNoteAccountName";

interface NoteDeleteTeamBodyProps {
  note: Note;
}

export const NoteDeleteTeamBody = ({ note }: NoteDeleteTeamBodyProps) => {
  const account = useNoteAccount(note);
  const accountName = useNoteAccountName(note);
  return (
    <NoteBody note={note}>
      <Text width={"100%"} textAlign={"center"} marginLeft={2} marginRight={2}>
        <Link
          color={THEME_COLOR_SCHEME}
          as={ReactRouterLink}
          to={`/account/${account?.id}`}
        >
          {accountName}
        </Link>
        deleted team "{note.message}"
      </Text>
    </NoteBody>
  );
};
